module.exports = __webpack_public_path__ + "assets/img/coderight.67dcd882.png";